import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bienvenue !");
      navigate(res.user.role === "admin" ? "/admin" : "/espace-client");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <section className="min-h-[80vh] flex items-center py-20">
      <div className="mx-auto max-w-md w-full px-6">
        <div className="text-center mb-10">
          <div className="h-14 w-14 rounded-2xl bg-[#2196F3] flex items-center justify-center mx-auto mb-6">
            <Lock className="h-7 w-7 text-white" />
          </div>
          <h1 className="font-display text-4xl font-extrabold text-slate-900">Espace client</h1>
          <p className="text-slate-600 mt-2">Connectez-vous pour accéder à votre espace personnel.</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8 space-y-5" data-testid="login-form">
          <div className="space-y-2">
            <Label htmlFor="lemail">Email</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <Input id="lemail" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="pl-10 h-12" placeholder="vous@email.fr" data-testid="login-email" />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="lpwd">Mot de passe</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <Input id="lpwd" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="pl-10 h-12" placeholder="••••••••" data-testid="login-password" />
            </div>
          </div>
          <div className="flex justify-end -mt-1">
            <Link to="/mot-de-passe-oublie" className="text-xs text-[#2196F3] hover:text-[#1976D2] font-semibold" data-testid="login-forgot-link">
              Mot de passe oublié ?
            </Link>
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-[#2196F3] hover:bg-[#1976D2] text-white h-12" data-testid="login-submit">
            {loading ? "Connexion…" : (<>Se connecter <LogIn className="ml-2 h-4 w-4" /></>)}
          </Button>
          <div className="text-center text-sm text-slate-500 pt-2">
            Pas encore de compte ?{" "}
            <Link to="/inscription" className="text-[#2196F3] hover:text-[#1976D2] font-semibold" data-testid="login-register-link">
              Créer un compte
            </Link>
          </div>
        </form>
      </div>
    </section>
  );
}
